<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
      [class.fa-plus-square-o]="minimise"
      [class.fa-minus-square-o]="!minimise"
      style="margin-right: 10px; cursor: pointer;"
      (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id; currentTabName = tab.name" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!showFormLoader && formEntryData) {
<div>
          <!-- AMT Table (Section 1) -->
          <div class="row" style="padding-top: 20px;">
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  @for (header of formEntryData.section1.section1Headers; track $index) {
<th>{{ header }}</th>
}
                </tr>
              </thead>
              <tbody>
                @for (row of formEntryData.section1.rows; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td>{{ row.description }}</td>
                  <td colspan="4"></td>
                  <td colspan="4"></td>
                </tr>
}
                @for (row of formEntryData.section1.rows1; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td colspan="10">{{ row.description }}</td>
                </tr>
}
                @for (row of formEntryData.section1.rows2; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td>{{ row.description }}</td>
                  <td>@if (row.input?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.input ? row.input.val : ''" (ngModelChange)="onEntryCellChange(row, 'input', $event)">
}</td>
                  <td>@if (row.pshipK1?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.pshipK1 ? row.pshipK1.val : ''" (ngModelChange)="onEntryCellChange(row, 'pshipK1', $event)">
}</td>
                  <td>@if (row.gbs?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.gbs ? row.gbs.val : ''" (ngModelChange)="onEntryCellChange(row, 'gbs', $event)">
}</td>
                  <td>@if (row.total?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.total ? row.total.val : ''" (ngModelChange)="onEntryCellChange(row, 'total', $event)">
}</td>
                  <td>@if (row.us?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.us ? row.us.val : ''" (ngModelChange)="onEntryCellChange(row, 'us', $event)">
}</td>
                  <td>@if (row.generalLimitation?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.generalLimitation ? row.generalLimitation.val : ''" (ngModelChange)="onEntryCellChange(row, 'generalLimitation', $event)">
}</td>
                  <td>@if (row.passive?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.passive ? row.passive.val : ''" (ngModelChange)="onEntryCellChange(row, 'passive', $event)">
}</td>
                  <td>@if (row.treaty?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.treaty ? row.treaty.val : ''" (ngModelChange)="onEntryCellChange(row, 'treaty', $event)">
}</td>
                </tr>
}
              </tbody>
            </table>
          </div>
          <!-- ACE Table (Section 2) -->
          <div class="row">
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  @for (header of formEntryData.section2.section2Headers; track $index) {
<th>{{ header }}</th>
}
                </tr>
              </thead>
              <tbody>
                @for (row of formEntryData.section2.rows; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td>{{ row.description }}</td>
                  <td colspan="4"></td>
                  <td colspan="4"></td>
                </tr>
}
                @for (row of formEntryData.section2.rows1; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td colspan="9">{{ row.description }}</td>
                </tr>
}
                @for (row of formEntryData.section2.rows2; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td>{{ row.description }}</td>
                  <td>@if (row.input?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.input ? row.input.val : ''" (ngModelChange)="onEntryCellChange(row, 'input', $event)">
}</td>
                  <td>@if (row.pshipK1?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.pshipK1 ? row.pshipK1.val : ''" (ngModelChange)="onEntryCellChange(row, 'pshipK1', $event)">
}</td>
                  <td>@if (row.gbs?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.gbs ? row.gbs.val : ''" (ngModelChange)="onEntryCellChange(row, 'gbs', $event)">
}</td>
                  <td>@if (row.total?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.total ? row.total.val : ''" (ngModelChange)="onEntryCellChange(row, 'total', $event)">
}</td>
                  <td>@if (row.us?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.us ? row.us.val : ''" (ngModelChange)="onEntryCellChange(row, 'us', $event)">
}</td>
                  <td>@if (row.generalLimitation?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.generalLimitation ? row.generalLimitation.val : ''" (ngModelChange)="onEntryCellChange(row, 'generalLimitation', $event)">
}</td>
                  <td>@if (row.passive?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.passive ? row.passive.val : ''" (ngModelChange)="onEntryCellChange(row, 'passive', $event)">
}</td>
                  <td>@if (row.treaty?.show) {
<input class="form-control text-right" type="text" [ngModel]="row.treaty ? row.treaty.val : ''" (ngModelChange)="onEntryCellChange(row, 'treaty', $event)">
}</td>
                </tr>
}
              </tbody>
            </table>
          </div>
          <!-- AMT Section 3 -->
          <div class="row">
            <table class="table table-bordered custom-table">
              <thead>
                <tr>
                  @for (header of formEntryData.section1.section1Headers; track $index) {
<th>{{ header }}</th>
}
                </tr>
              </thead>
              <tbody>
                @for (row of formEntryData.section3.rows; track $index) {
<tr>
                  <td>{{ row.num }}</td>
                  <td colspan="4">{{ row.description }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
}
              </tbody>
            </table>
          </div>
          <div class="row form-group">
            <span class="col-md-10">
              <i class="fa fa-info-circle fa-lg"></i>
              <label><span>Note that there is a foreign sourced data in FSI screen.</span></label>
            </span>
          </div>
          <div class="row form-group">
            <span class="col-md-10">
              <input type="checkbox" [checked]="confirmNoForeignSourcing" (change)="onConfirmNoForeignSourcingChange($event)">
              <label>By checking this box, you are confirming that AMT/ACE adjustments don't have any applicable foreign sourcing.</label>
            </span>
          </div>
          <div class="row form-group">
            <span class="col-md-6">
              <label>Explain:</label>
              <textarea name="message" placeholder="Add Message" style="height:120px" class="form-control input-sm" [ngModel]="explainMessage" (ngModelChange)="explainMessage = $event"></textarea>
            </span>
          </div>
        </div>
}
      </div>
    </div>
}

    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      @if (formViewData) {
<div class="form-horizontal">
        <div class="row">
          <table class="table table-bordered custom-table">
            <thead>
              <tr>
                @for (header of formViewData.FormViewHeaders; track $index) {
<th>{{ header }}</th>
}
              </tr>
            </thead>
            <tbody>
              @for (row of formViewData.FormViewBody.rows; track $index) {
<tr>
                <td>{{ row.num }}</td>
                <td>{{ row.description }}</td>
                <td>{{ row.amount }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
}
    </div>
}
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName === 'Form Entry') {
<button
    class="save-button"
    type="button"
    [disabled]="isSaveClicked"
    (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName === 'Form Entry') {
<button
    class="reset-button"
    type="button"
    (click)="reset()">Reset</button>
}
  <button class="cancel-button"
    type="button"
    (click)="cancel()">Cancel</button>
</div>
